import { render, staticRenderFns } from "./UpgradeContent.vue?vue&type=template&id=501fb9ac&scoped=true&"
import script from "./UpgradeContent.vue?vue&type=script&lang=js&"
export * from "./UpgradeContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501fb9ac",
  null
  
)

export default component.exports